/* istanbul ignore file */
export enum BundleType {
  Standalone = 'BUNDLETYPE_STANDALONE',
  Anchor = 'BUNDLETYPE_WPANCHOR',
  NonAnchor = 'BUNDLETYPE_WPNONANCHOR',
  NonAnchorStandalone = 'BUNDLETYPE_WPNONANCHORSTANDALONE'
}
type ChronicCareProduct = {
  start_dt: string | null;
  end_dt: string | null;
  bundleType: boolean;
  isEnabled: boolean;
};

export const DATE_FORMAT: string = 'YYYY-MM-DD';

export const emsMainCodeList = ['AAD', 'CC', 'MRS', 'TDS', 'BHN', 'FAD', 'EMO2'];
export const emsCodeList = [...emsMainCodeList, 'EFB'];
const glp1AdvancedProducts = ['ADVWM', 'ADPP'];
const glp1ComprehensiveProducts = ['COMWC', 'CDPC'];
const glp1Products = [...glp1AdvancedProducts, ...glp1ComprehensiveProducts];
export const careProducts = ['WEIGMCARE', 'DIABPCARE', 'DIABCARE', 'HYPTCARE'];
export const promoProducts = ['NUTPROMO'];
export const chronicCareCode: string[] = [
  'DIAB',
  'DIABP',
  'HYPT',
  'MYSTRPLUS',
  'WEIGM',
  'SPP',
  ...glp1Products,
  ...careProducts,
  ...promoProducts
];
export const plusProducts: string[] = ['DIAB', 'DIABP', 'HYPT', 'WEIGM', 'ADPP', 'ADVWM'];
export const completeProducts: string[] = ['DIABCARE', 'DIABPCARE', 'HYPTCARE', 'WEIGMCARE', 'COMWC', 'CDPC'];

export const chronicCareProductsDefaults = chronicCareCode.reduce<Record<string, ChronicCareProduct>>((acc, code) => {
  acc[code] = {
    start_dt: null,
    end_dt: null,
    bundleType: false,
    isEnabled: false
  };
  return acc;
}, {});
export const chronicCareGeneralFormSettings: string[] = [
  'products--chronicCare--end_dt',
  'products--chronicCare--start_dt',
  'products--chronicCare--isEnabled',
  'products--chronicCare--error'
];

export const productCodes = {
  ems: 'EMS',
  bh: 'BH',
  p360: 'PRIM360CARE'
};
export const formArrayTypeDivider = '--';
export const allowedPublishField = {
  id: '',
  metaDataId: '',
  planNumber: '',
  name: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  zip: '',
  start_dt: '',
  end_dt: '',
  total_lives: '',
  total_employee: '',
  instructions: '',
  terminateReason: '',
  groups: [
    {
      id: '',
      planCodes: [
        {
          code: '',
          classCodes: [
            {
              code: '',
              start_dt: '',
              end_dt: ''
            }
          ],
          bpCodes: [
            {
              code: '',
              start_dt: '',
              end_dt: ''
            }
          ]
        }
      ],
      name: '',
      instructions: '',
      start_dt: '',
      end_dt: '',
      reg_type: '',
      language: '',
      legacyGroupId: '',
      futureProducts: [
        {
          code: '',
          start_dt: '',
          member_copay: '',
          type: '',
          could_be_less: '',
          app_opt_out: ''
        }
      ],
      futureProductsCCM: [
        {
          code: '',
          start_dt: '',
          end_dt: '',
          bundleType: ''
        }
      ],
      products: [
        {
          start_dt: '',
          end_dt: '',
          member_copay: '',
          cost_per_person: '',
          could_be_less: '',
          app_opt_out: '',
          code: '',
          type: '',
          bundleType: '',
          enable_adolescent_visits: '',
          model: '',
          promotion: ''
        }
      ]
    }
  ],
  contacts: [
    {
      type: '',
      first: '',
      last: '',
      phone: '',
      email: '',
      company: '',
      __auditTempId: ''
    }
  ]
};
export const allowedDraftField = {
  logo: {
    action: '',
    image: ''
  },
  ...allowedPublishField
};

export const TERMINATION_REASON_OTHER: string = 'Other';

export const terminationReasons = [
  {
    label: 'Bankruptcy/Financial Constraints',
    value: 'Bankruptcy/Financial Constraints'
  },
  {
    label: 'Dissatisfaction - Teladoc Systems',
    value: 'Dissatisfaction - Teladoc Systems'
  },
  {
    label: 'Dissatisfaction - Member Experience',
    value: 'Dissatisfaction - Member Experience'
  },
  {
    label: 'Dissatisfaction - Reporting',
    value: 'Dissatisfaction - Reporting'
  },
  {
    label: 'Leaving Reseller / TPA / Health Plan',
    value: 'Leaving Reseller / TPA / Health Plan'
  },
  {
    label: 'Low Utilization/ROI',
    value: 'Low Utilization'
  },
  {
    label: 'Merger/Acquisition',
    value: 'Merger/Acquisition'
  },
  {
    label: 'Moved to Internal Embedded Solution - Stayed with TDH',
    value: 'Moved to Internal Embedded Solution - Stayed with TDH'
  },
  {
    label: 'Moved to External Embedded Solution - Left TDH',
    value: 'Moved to External Embedded Solution - Left TDH'
  },
  {
    label: 'Moving to Other Teladoc Plan',
    value: 'Moving to Other Teladoc Plan'
  },
  {
    label: 'No Sr. Relationship',
    value: 'No Sr. Relationship'
  },
  {
    label: 'RFP/Competitor Play',
    value: 'RFP/Competitor Play'
  },
  {
    label: TERMINATION_REASON_OTHER,
    value: TERMINATION_REASON_OTHER
  }
];
